<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a href="/" class="navbar-brand"><img src="assets/img/apphoc-logo.png" height="45" width="150" /></a>
    <app-auth-nav class="ml-auto"></app-auth-nav>
</nav>
<div class="container">
    <app-supplier-register-data></app-supplier-register-data>
</div>


